import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import { CircularProgress } from "@mui/material";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import { theme } from "./config/theme";
import { RootPage } from "./pages/RootPage";
import { AppGlobalStyles } from "./config/AppGlobalStyles";

import reportWebVitals from "./reportWebVitals";

import { bootstrap } from "./config/bootstrap";
import { FlexCentered } from "./components/layout/FlexCenterd";
import { GlobalErrorFallBack } from "./components/boundary/GlobalErrorFallBack";
import { ReactQueryDevtools } from "react-query/devtools";
import { PageLoader } from "components/page/loader/PageLoader";

bootstrap();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
      retry: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}>
      <Suspense fallback={<PageLoader />}>
        <CssBaseline />
        <AppGlobalStyles />
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary FallbackComponent={GlobalErrorFallBack}>
            <BrowserRouter>
              <RootPage />
              <ReactQueryDevtools />
            </BrowserRouter>
          </ErrorBoundary>
        </QueryClientProvider>
      </Suspense>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
